import React from "react";
import sidebarStyles from "styles/sidebar.module.scss";
import pageStyles from "styles/page.module.scss";
import Logo from "svgs/logo_v2.png";

// Static, dependency-free app shell shown WHILE shop data loads (Authenticator
// gate). It paints immediately at JS-ready — a large heading + the real nav
// labels give the browser an early, contentful LCP candidate instead of a bare
// centered spinner that only resolved after the GET_SHOP_SETTINGS round-trip.
// It reuses the real sidebar/layout CSS so swapping in the loaded UI causes no
// layout shift. Purely presentational: no context, hooks, or router — it can
// never crash the boot.
const NAV_LABELS = [
  "Getting started",
  "Dashboard",
  "Cart Setup",
  "Upsell Campaigns",
  "Sticky cart",
  "Integrations",
  "Your Plan",
  "Faq"
];

export default function AppShellSkeleton() {
  return (
    <div className={pageStyles.app_wrapper} aria-busy="true">
      <div className={sidebarStyles.sidebar}>
        <div className={sidebarStyles.logo}>
          <img src={Logo} alt="Monster Upsell" />
        </div>
        <div className={sidebarStyles.menu}>
          {NAV_LABELS.map((label) => (
            <div key={label} className={sidebarStyles.menu_item}>
              <div>
                <span className={sidebarStyles.text}>{label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div style={{ flex: 1, minWidth: 530, padding: "32px 40px" }}>
        <h1 style={{ fontSize: 28, fontWeight: 700, color: "#1a1a1a", margin: 0 }}>
          Loading your dashboard…
        </h1>
        <div style={{ marginTop: 24, display: "flex", flexDirection: "column", gap: 16 }}>
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              aria-hidden="true"
              style={{ height: 120, borderRadius: 12, background: "#f1f1f1" }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
